module.exports = __webpack_public_path__ + "static/media/bowling.18502c43.webp";